import { Carousel } from '@mantine/carousel';
import { Grid, Group, rem, Stack, Text, Tooltip } from '@mantine/core';
import { IconChevronLeft, IconChevronRight } from '@tabler/icons-react';

const CarouselCardForCategories = (props) => {
  const buckets = props.hits;
  const metrics = props.metrics;

  const chunkedBuckets = buckets?.reduce((acc, bucket, index) => {
    if (index % 4 === 0) {
      acc.push([]);
    }
    acc[acc.length - 1].push(bucket);
    return acc;
  }, []);

  // Don't show carousel controls if there's only one page
  const hasMultiplePages = chunkedBuckets?.length > 1;

  const CategoryDetailsCard = ({ entry }) => {
    return (
      <Grid.Col span={{ base: 12, md: 3 }}>
        <Stack
          align="center"
          gap="xs"
          style={{ borderRight: '1px solid rgba(136, 136, 136, 0.2)', height: '100%' }}
          py="sm"
        >
          <Tooltip label={entry.key} position="top">
            <Text size="sm" fw={600} c="primary" ta="center" lineClamp={2}>
              {entry?.key}
            </Text>
          </Tooltip>
          <Group
            gap="md"
            justify="center"
            pt="xs"
            style={{ borderTop: '1px solid rgba(136, 136, 136, 0.2)', width: '100%' }}
          >
            <Stack gap={0} align="center">
              <Text size="xs" c="dimmed">{metrics[0].title}</Text>
              <Text size="sm" fw={600}>{entry?.total_score?.value?.toLocaleString('en-US')}</Text>
            </Stack>
            {metrics[1] && (
              <Stack gap={0} align="center">
                <Text size="xs" c="dimmed">{metrics[1].title}</Text>
                <Text size="sm" fw={600}>{entry?.doc_count?.toLocaleString('en-US')}</Text>
              </Stack>
            )}
          </Group>
        </Stack>
      </Grid.Col>
    );
  };

  return (
    <Carousel
      withIndicators={false}
      withControls={hasMultiplePages}
      loop={hasMultiplePages}
      slideSize="100%"
      slideGap={0}
      align="start"
      nextControlIcon={<IconChevronRight style={{ width: rem(24), height: rem(24) }} />}
      previousControlIcon={<IconChevronLeft style={{ width: rem(24), height: rem(24) }} />}
      styles={{
        root: {
          position: 'relative',
        },
        control: {
          backgroundColor: 'var(--mantine-color-gray-0)',
          border: '1px solid var(--mantine-color-gray-3)',
          boxShadow: 'var(--mantine-shadow-sm)',
          width: rem(36),
          height: rem(36),
          opacity: 1,
          '&[data-inactive]': {
            opacity: 0,
            cursor: 'default',
          },
        },
        controls: {
          position: 'absolute',
          top: '50%',
          transform: 'translateY(-50%)',
          left: 0,
          right: 0,
          padding: '0 4px',
        },
      }}
    >
      {chunkedBuckets.map((bucket, index) => (
        <Carousel.Slide key={index}>
          <Grid px="xl">
            {bucket.map((b, innerIndex) => (
              <CategoryDetailsCard key={innerIndex} entry={b} />
            ))}
          </Grid>
        </Carousel.Slide>
      ))}
    </Carousel>
  );
};

export default CarouselCardForCategories;
